// src/firebaseConfig.js
// -----------------------------------------------------------------------------
// 🔥 Firebase Setup for Only Believe Hymn Dashboard
// This file connects your React CMS to Firebase Authentication + Firestore.
// -----------------------------------------------------------------------------
// Author: Justice Kwesi Akuffo (Grace I.T Services)
// -----------------------------------------------------------------------------
// PRO TIPS:
// - Never hardcode secrets into a public repo. Use .env variables for production.
// - This version includes sanity checks and Google Auth provider support.
// -----------------------------------------------------------------------------

import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// ✅ Corrected Config
// Your storage bucket was slightly off (missing ".appspot.com")
const firebaseConfig = {
  apiKey: "AIzaSyAFmvNZJu63J8hlKJwlSP6p2GFHDyfoTmw",
  authDomain: "onlybelieveapps.firebaseapp.com",
  projectId: "onlybelieveapps",
  storageBucket: "onlybelieveapps.appspot.com", // ✅ fixed from firebasestorage.app → appspot.com
  messagingSenderId: "320535632113",
  appId: "1:320535632113:web:35fda8e14eb2446627b150",
  measurementId: "G-4J44PPW3KD",
};

// ✅ Prevent re-initialization errors during hot reloads
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// ✅ Firebase modules
export const auth = getAuth(app);
export const db = getFirestore(app);

// ✅ Google sign-in (used in Login.jsx)
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

// Optional: Add default export if needed
export default app;

// -----------------------------------------------------------------------------
// 💡 Notes:
// - Firestore: powers HymnForm, HymnList, AuthorList, KeyList.
// - Auth: powers Login.jsx and logout features in App.jsx.
// - This file is safe for both local dev and Vercel/Firebase Hosting builds.
// -----------------------------------------------------------------------------
